module.exports = __webpack_public_path__ + "img/h3d3.6e1bbb02.png";